export default "__VITE_ASSET__f27bdd99__"